import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UntilDestroy } from '@ngneat/until-destroy';

import { VISUAL_EFFECT_OPTIONS } from '@blaze-shared/elements-domain';

@UntilDestroy()
@Component({
  selector: 'blaze-visual-effect-config-dialog',
  templateUrl: './visual-effect-config-dialog.component.html',
  styleUrls: ['./visual-effect-config-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class VisualEffectConfigDialogComponent {
  private dialogRef = inject<MatDialogRef<VisualEffectConfigDialogComponent>>(MatDialogRef);

  form: FormGroup;

  get title(): string {
    return (
      VISUAL_EFFECT_OPTIONS.find((effect) => effect.value === this.form.value.effectType)?.label ??
      'Effect'
    );
  }
  constructor() {
    const form = inject<FormGroup>(MAT_DIALOG_DATA);

    this.form = form;
  }

  close(): void {
    this.dialogRef.close();
  }
}
